function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleFilterGroup = exports.FilterGroup = exports.DefaultFilterGroupEventKey = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _components = require("../../components");
var _styles2 = require("../../styles");
var _reactNativeEventListeners = require("react-native-event-listeners");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["eventKey"],
  _excluded2 = ["title", "hideTitle", "items", "selectedItems", "visibleRows", "showMoreLabel", "showLessLabel", "style", "onPress", "showMore", "hiddenFilters", "eventKey"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var DefaultFilterGroupEventKey = exports.DefaultFilterGroupEventKey = 'showFilterGroupKey';
var ToggleFilterGroup = exports.ToggleFilterGroup = function ToggleFilterGroup(_ref) {
  var _ref$eventKey = _ref.eventKey,
    eventKey = _ref$eventKey === void 0 ? DefaultFilterGroupEventKey : _ref$eventKey,
    state = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  _reactNativeEventListeners.EventRegister.emit(eventKey, state);
};
var FilterGroup = exports.FilterGroup = (0, _react.memo)(function (_ref2) {
  var title = _ref2.title,
    _ref2$hideTitle = _ref2.hideTitle,
    hideTitle = _ref2$hideTitle === void 0 ? false : _ref2$hideTitle,
    items = _ref2.items,
    _ref2$selectedItems = _ref2.selectedItems,
    selectedItems = _ref2$selectedItems === void 0 ? [] : _ref2$selectedItems,
    visibleRows = _ref2.visibleRows,
    showMoreLabel = _ref2.showMoreLabel,
    showLessLabel = _ref2.showLessLabel,
    style = _ref2.style,
    onPress = _ref2.onPress,
    _ref2$showMore = _ref2.showMore,
    showMore = _ref2$showMore === void 0 ? false : _ref2$showMore,
    _ref2$hiddenFilters = _ref2.hiddenFilters,
    hiddenFilters = _ref2$hiddenFilters === void 0 ? [] : _ref2$hiddenFilters,
    _ref2$eventKey = _ref2.eventKey,
    eventKey = _ref2$eventKey === void 0 ? DefaultFilterGroupEventKey : _ref2$eventKey,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _showMore = _useState2[0],
    _setShowMore = _useState2[1];
  var _useState3 = (0, _react.useState)(visibleRows && items.length > 5),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    _showButton = _useState4[0],
    _setShowButton = _useState4[1];
  var _useState5 = (0, _react.useState)(hiddenFilters),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    _hiddenFilters = _useState6[0],
    _setHiddenFilters = _useState6[1];
  var _filters = (0, _react.useRef)({});
  var _containerRef = (0, _react.useRef)(null);
  var _filterHeight = 2.5 * _reactNative.PixelRatio.getFontScale() * _styles2.baseSize;
  var _filterMargin = 0.1875 * _reactNative.PixelRatio.getFontScale() * _styles2.baseSize;
  var _filterFullHeight = _filterHeight + _filterMargin * 2;
  var _checkFilters = (0, _react.useCallback)(function () {
    if (!visibleRows || !_filters.current || !_containerRef.current) return;
    var _tempFilters = [];
    var _checkedFilters = [];
    var _loop = function _loop(_key) {
      var _filters$current$_key;
      (_filters$current$_key = _filters.current[_key]) == null ? void 0 : _filters$current$_key.measureLayout(_containerRef.current, function (_left, top) {
        _checkedFilters.push(_key);
        var _hide = top >= _filterFullHeight * visibleRows;
        if (_hide) {
          _tempFilters.push(_key);
        }
        if (_checkedFilters.length === items.length) {
          _setHiddenFilters(_tempFilters);
          _setShowButton(false);
        }
      }, function () {});
    };
    for (var _key in _filters.current) {
      _loop(_key);
    }
  }, [_filterFullHeight, items.length, visibleRows]);
  var _toggleOnPress = function _toggleOnPress() {
    _setShowMore(!_showMore);
  };
  var _onLayout = function _onLayout() {
    _checkFilters();
  };
  (0, _react.useEffect)(function () {
    _setShowMore(showMore);
  }, [showMore]);
  (0, _react.useEffect)(function () {
    var _listener = _reactNativeEventListeners.EventRegister.addEventListener(eventKey, function (newState) {
      _setShowMore(newState.showMore || !_showMore);
    });
    return function () {
      _reactNativeEventListeners.EventRegister.removeEventListener(_listener);
    };
  }, [_showMore, eventKey]);
  if (!items || items.length === 0) return null;
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_reactNative.View, {
      onLayout: _onLayout
    }), (0, _jsxRuntime.jsxs)(_components.FieldSet, Object.assign({
      style: [styles.container, style],
      testID: "FilterGroup",
      legend: title
    }, props, {
      children: [!hideTitle && (0, _jsxRuntime.jsx)(_reactNative.Text, {
        style: styles.title,
        children: title
      }), (0, _jsxRuntime.jsx)(_reactNative.View, {
        ref: _containerRef,
        style: [styles.filters, !_showMore && !!visibleRows && {
          maxHeight: _filterFullHeight * visibleRows
        }],
        children: items.map(function (item) {
          var _isActive = selectedItems.includes(item.slug);
          var _isHidden = !_showMore && _hiddenFilters.includes(item.slug);
          return (0, _jsxRuntime.jsx)(_components.Filter, Object.assign({}, item, {
            isActive: _isActive,
            onPress: onPress,
            style: {
              margin: _filterMargin,
              height: _filterHeight
            },
            hide: _isHidden,
            ref: function ref(itemRef) {
              return _filters.current[item.slug] = itemRef;
            }
          }), "filter-".concat(item.slug));
        })
      }), (_showButton || _hiddenFilters.length > 0) && (0, _jsxRuntime.jsx)(_components.Button, {
        label: _showMore ? showLessLabel : showMoreLabel,
        type: _components.ButtonType.brand,
        onPress: _toggleOnPress,
        testID: "FilterGroupToggle",
        containerStyle: styles.toggle
      })]
    }))]
  });
});